import {
  Avatar,
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Image,
  Text,
  useToast,
} from "@chakra-ui/react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import engineering from "../../img/engring.png";
import { ICourseApplication } from "../../models/course-application.model";
import Adminroutes from "../../pages/admin/routes";
import AdminHelpers from "../../services/admin/admin.service";
import courseEnrolmentService from "../../services/course-enrolment.service";
import Loading from "../common/Loading";

export default function CourseApplication() {
  const navigate = useNavigate();
  const { course_id } = useParams();
  const toast = useToast();
  const [course, setCourse] = useState<ICourseApplication>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    courseEnrolmentService
      .getEachApplication(course_id)
      .then((response) => {
        setCourse(response.data);

        setLoading(false);
      })
      .catch((err) => err);
  }, []);

  // const approveCourse = () => {
  //     const approvePayload = {
  //         ids: [course?.id],
  //         action: 'Approve'
  //     }
  //     courseEnrolmentService.approve_decline_course(approvePayload).then(
  //         (res) => {
  //
  //             toast({
  //                 title: "Course Application",
  //                 description: "Course application approved  successfully",
  //                 status: "success",
  //             })
  //             navigate(-1)
  //         }
  //     )
  // }

  const declineCourse = () => {
    const approvePayload = {
      ids: [course && course.id],
      action: "Decline",
    };
    courseEnrolmentService
      .approve_decline_course(approvePayload)
      .then((res) => {
        toast({
          title: "Course Application",
          description: "Course Application declined",
          status: "success",
        });
        navigate(-1);
      });
  };

  const handleShortlistApplications = async (Id: number | undefined) => {
    const checkedIds = [Id];
    if (checkedIds.length !== 0 || checkedIds !== null) {
      const data = {
        application_ids: checkedIds,
      };

      try {
        const Res = await AdminHelpers.shortlistApplication(data);
        if (Res) {
          toast({
            title: "Shortlist Application",
            description: `Applicant shortlisted successfully`,
            status: "success",
          });
          navigate(-1);
        }
      } catch (error: any) {
        toast({
          title: "Shortlist Application",
          description: `Something went wrong`,
          status: "error",
        });
      }
    } else {
      toast({
        title: "Shortlist Application",
        description: `Select applicants you want to shortlist`,
        status: "error",
      });
      return;
    }
  };

  return (
    <Box minHeight="100vh" bg="#F9F8F8">
      {loading ? (
        <Loading />
      ) : (
        <Container
          width={"58%"}
          maxWidth={"84%"}
          px={0}
          pt="100px"
          right={0}
          bg="F9F8F8"
          mx="auto"
        >
          <Box
            mb="60px"
            display="flex"
            alignItems="center"
            border="1px solid #616161"
            px="5px"
            py="7px"
            width="190px"
            borderRadius="5px"
            cursor="pointer"
          >
            <HiArrowNarrowLeft color="#616161" fontSize="20px" />
            <Text
              fontSize="14px"
              color="#616161"
              pl="5px"
              onClick={() => navigate(Adminroutes.Review)}
              fontWeight={700}
            >
              Back to review
            </Text>
          </Box>
          <Box bg="white" px="40px" py="40px">
            <Box>
              <Text
                textAlign="center"
                color="#353535"
                fontSize="24px"
                fontWeight="700"
                pb="40px"
              >
                Applicant Course Review
              </Text>
            </Box>
            <Flex
              justifyContent="space-between"
              boxShadow="base"
              pt="25px"
              pb="15px"
              mb="20px"
              px="30"
              borderRadius="10px"
            >
              <HStack spacing="10px">
                <Avatar name={course?.user.name} size="sm" />

                <Text color="#353535" fontSize="21px" fontWeight="700">
                  {course?.user.name}
                </Text>
              </HStack>
              <Box>
                <Text color="#757575" fontSize="14px">
                  Application ID
                </Text>
                <Text color="#353535" fontSize="16px" fontWeight="700">
                  {course?.uuid}
                </Text>
              </Box>
              <Box>
                <Text color="#757575" fontSize="14px">
                  Trainee ID
                </Text>
                <Text color="#353535" fontSize="16px" fontWeight="700">
                  {course?.user.id}
                </Text>
              </Box>
            </Flex>
            <Flex
              justifyContent="space-between"
              pt="25px"
              boxShadow="base"
              mb="20px"
              pb="15px"
              px="30"
              borderRadius="10px"
            >
              <Box height="70px" width="120px">
                <Image
                  objectFit="cover"
                  src={
                    course?.course.cover_image
                      ? course.course.cover_image
                      : engineering
                  }
                  width="100px"
                  height="70px"
                />
              </Box>
              <Box fontWeight="600" fontSize="16px" ml="15px" color="#616161">
                <Text fontWeight="600" fontSize="16px" color="#616161">
                  {course?.course.name}
                </Text>
                <Text fontWeight="500" fontSize="14px" color="#616161">
                  {course?.course.description
                    ? course?.course.description.substring(0, 150)
                    : "NIL"}{" "}
                </Text>
              </Box>
            </Flex>
            <Box py="8px" borderRadius="8px" boxShadow="base">
              <Flex
                justifyContent="space-between"
                pt="25px"
                pb="15px"
                px="30"
                borderBottom="1px solid"
                borderColor="lightgray"
              >
                <Text>Training Cost (NGN)</Text>
                <Text>
                  <NumericFormat
                    value={course?.course.cost}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"₦"}
                  />
                </Text>
              </Flex>
              <Flex
                justifyContent="space-between"
                pt="25px"
                pb="15px"
                px="30"
                borderBottom="1px solid"
                borderColor="lightgray"
              >
                <Text>Amount Owed (NGN)</Text>
                <Text>{course?.payment_ids}</Text>
              </Flex>
              <Flex
                justifyContent="space-between"
                pt="25px"
                pb="15px"
                px="30"
                borderBottom="1px solid"
                borderColor="lightgray"
              >
                <Text>Payment Type</Text>
                <Text>{course?.payment_mode}</Text>
              </Flex>
              <Flex
                justifyContent="space-between"
                pt="25px"
                pb="15px"
                px="30"
                borderBottom="1px solid"
                borderColor="lightgray"
              >
                <Text>Transaction Reference No.</Text>
                <Text>{course?.payment_ids}</Text>
              </Flex>
              <Flex justifyContent="space-between" pt="25px" pb="15px" px="30">
                <Text>Duration</Text>
                <Text>{`${course?.course.duration} ${course?.course.duration_unit}`}</Text>
              </Flex>
            </Box>
            <Flex
              justifyContent="flex-end"
              gap="0.5rem"
              alignItems="center"
              mb="30px"
            >
              <Button
                py="13px"
                px="30px"
                mt="30px"
                type="submit"
                fontSize={16}
                onClick={() => {
                  declineCourse();
                }}
                bg="#F5F5F5"
                color="#353535"
                size="md"
              >
                Decline
              </Button>
              <Button
                colorScheme="red"
                fontSize="16px"
                fontWeight="700"
                py="13px"
                px="24px"
                mt="30px"
                size="md"
                onClick={() => handleShortlistApplications(course?.id)}
              >
                SHORTLIST
              </Button>
            </Flex>
          </Box>
        </Container>
      )}
    </Box>
  );
}
